@if (order) {
  <div class="request-refund-dialog-content" mat-dialog-content>
    <div class="dialog-header">
      <div class="dialog-title-with-progress-cont">
        @if (step <= numberOfSteps) {
          @if (isDesktop) {
            <app-progress-indicator
              [currentStep]="step"
              [numberOfSteps]="numberOfSteps"
              [isCircle]="true"
            >
            </app-progress-indicator>
          } @else if (!isDesktop) {
            <div class="mobile-back" (click)="previousStep()">
              <i class="far fa-chevron-left icon-regular"></i>
            </div>
          }
        }

        <div class="dialog-title-custom">
          {{ headerTitle | translate }}
          @if (!isDesktop && step > 1 && step <= numberOfSteps) {
            ({{ step }}/{{ numberOfSteps }})
          }
        </div>
      </div>

      <div class="close-button-custom">
        <i class="far fa-times icon-regular" (click)="close()"></i>
      </div>
    </div>

    @if (!isDesktop && step <= numberOfSteps) {
      <app-progress-indicator
        [currentStep]="step"
        [numberOfSteps]="numberOfSteps"
      >
      </app-progress-indicator>
    }
    <div class="dialog-body">
      @if (step === 1) {
        <div class="change-timeslot-process">
          <div class="process-title">
            {{ "APP.REQUEST_REFUND.BOOKED_WRONG_TIMESLOT" | translate }}
          </div>
          <div class="process-description">
            {{ "APP.REQUEST_REFUND.WRONG_TIMESLOT_DESCRIPTION" | translate }}
          </div>
        </div>
      }

      @if (form && step === 2) {
        <app-book-event-slot-choose-slot
          [chosenSlot]="chosenSlot"
          [order]="order"
          [chosenTicket]="chosenTicket"
          [orderTickets]="orderTickets"
          [isDesktop]="isDesktop"
          (addSlotTicket)="addSlotTicket($event)"
          (removeSlotTicket)="removeSlotTicket($event)"
          (slotChosen)="onSlotChosen($event)"
        />
      }
      @if (form && step === 3) {
        <div class="event-order-wrapper">
          <!--Event info-->
          <ng-container *ngTemplateOutlet="eventInfo"></ng-container>
          <div class="tickets-info">
            {{ order.eventAttendeeTickets.length }} x {{ chosenTicket.name }} |
            {{ event?.name }}
          </div>
        </div>
        <div class="divider"></div>
        <div class="book-a-slot-terms">
          <div class="accept-terms">
            <mat-checkbox (change)="toggleTermsAndConditions()"></mat-checkbox>
            {{ "APP.I_AGREE_TO" | translate }}
            <a [href]="termsAndConditionsLink" target="_blank"
              >{{ "APP.THE_TERMS_AND_CONDITIONS" | translate }}.</a
            >*
          </div>
          <div class="accept-terms">
            <mat-checkbox (change)="toggleDataPrivacy()"></mat-checkbox>
            {{ "APP.I_AGREE_TO" | translate }}
            <a [href]="dataPrivacyLink" target="_blank"
              >{{ "APP.THE_PRIVACY_POLICY" | translate }}.</a
            >*
          </div>
          <div class="accept-terms marketing">
            <mat-checkbox (change)="toggleAcceptMarketing()"></mat-checkbox>
            <span>
              {{ "APP.ACCEPT_MARKETING" | translate }}
              <a [href]="dataPrivacyLink" target="_blank"
                >{{ "APP.MARKETING_PRIVACY_POLICY" | translate }}.</a
              >
            </span>
          </div>
        </div>
      }

      @if (step === 4) {
        <div class="event-order-wrapper">
          <!--Event info-->
          <ng-container *ngTemplateOutlet="eventInfo"></ng-container>
          <div class="divider"></div>
          <div class="tickets-info">
            {{ order.eventAttendeeTickets.length }} x {{ chosenTicket.name }} |
            {{ event?.name }}
          </div>
        </div>
      }
    </div>
    <div class="dialog-actions">
      @if (step === 1) {
        <button class="btn btn-primary-outline" (click)="close()">
          {{ "APP.GO_BACK" | translate }}
        </button>
        <button class="btn btn-primary" (click)="goNext()">
          {{ "APP.REQUEST_REFUND.SWITCH_THE_ORDER" | translate }}
        </button>
      } @else if (step === 2) {
        <button class="btn btn-primary" (click)="goNext()">
          {{ "APP.NEXT" | translate }}
        </button>
      } @else if (step === 3) {
        @if (isDesktop) {
          <button class="btn btn-primary-outline" (click)="previousStep()">
            {{ "APP.GO_BACK" | translate }}
          </button>
        }
        <button
          class="btn btn-primary"
          [class.spinner]="transferInProgress"
          [disabled]="this.transferInProgress || !checkIfCanTransferTickets()"
          (click)="changeEventSlot()"
        >
          {{ "APP.REQUEST_REFUND.TRANSFER_TICKETS_TO_SLOT" | translate }}
        </button>
      } @else if (step === 4) {
        <div class="row-actions">
          <button
            class="btn btn-primary-outline"
            (click)="openGetBoughtTicketsDialog()"
          >
            {{ "APP.BOOK_EVENT_SLOT.TO_YOUR_TICKET" | translate }}
          </button>
          @if (!isDesktop) {
            <div class="share-button small" (click)="addToCalendar()">
              <i class="far fa-calendar-day"></i>
            </div>
          }
        </div>
        @if (order.pdfTicketAvailable()) {
          <button class="btn btn-primary" (click)="downloadTicketPdf()">
            {{ "APP.EVENT_PAYMENT.GET_TICKETS" | translate }}
          </button>
        }

        @if (isDesktop) {
          <div class="share-button small" (click)="addToCalendar()">
            <i class="far fa-calendar-day"></i>
          </div>
        }
      }
    </div>
  </div>
}

<ng-template #eventInfo>
  @if (event && chosenSlot) {
    <div class="event-info-order-wrapper">
      <div class="event-info-wrapper">
        <div class="event-image-wrapper">
          <img
            [src]="event.getEncodedMainImage(true)"
            class="key-visual-img logo-image"
            alt="Key Visual"
          />
        </div>
        <div class="event-info">
          <div class="name">{{ event.name }} | {{ chosenTicket.name }}</div>
          <div class="date-address">
            <div class="date">
              {{
                DateUtils.formatEventDateRangeWithWeekday(
                  chosenSlot.startDate,
                  chosenSlot.endDate
                )
              }}
            </div>
          </div>
        </div>
      </div>
      <div class="location-wrapper">
        <div class="icon">
          <i class="fal fa-map-marker-alt"></i>
        </div>
        <div class="item">
          <div class="item-title">
            {{ event.getAddressDisplayNamePrimary() }}
          </div>
          <div class="value">
            {{ event.getAddressDisplayNameSecondary() }}
          </div>
        </div>
      </div>
    </div>
  }
</ng-template>
